import { z } from 'zod';
import { customerRef, userRef } from '../common';
import { RoleSubject } from './role';
export const auditLogRequest = z.object({
    userAgent: z.string().optional(),
    ip: z.string(),
});
export const auditLogReason = z.object({
    key: z.string(),
    reference: z.string().uuid(),
});
export const auditLog = z.object({
    customer: customerRef.nullable(),
    user: userRef,
    subject: z.nativeEnum(RoleSubject),
    action: z.string(),
    filter: z.record(z.unknown()),
    request: auditLogRequest.optional(),
    reason: auditLogReason.optional(),
    projection: z.record(z.unknown()).optional(),
    sort: z.record(z.number()).optional(),
    limit: z.number().optional(),
    skip: z.number().optional(),
});
